export default {
  getTalents: "/talents/selecttalenttool", //人才储备-列表页API
  addTalents: "/talents/inserttalenttool", //人才添加API
  editTalents: "/talents/updatetalenttool", //人才修改API
  isRequired:"/talents/getcount/{id}",//人才必填材料
}



// WEBPACK FOOTER //
// ./src/api/config/talents.js